import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <main id='main' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
